import {
    getCakeToOrderByUid,
    GetCakeToOrderByUidApiResponseSchema,
} from './get-cake-to-order-by-uid';

export {
    GetCakeToOrderByUidApiResponseSchema,
};

export const CakeToOrderPageActions = {
    getCakeToOrderByUid,
};
